module.exports = __webpack_public_path__ + "static/sp-small-cde6a7ef18b8f9ea0ecf15e90776d0c3.mp4";